import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const Delete: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden={!title}
      focusable='false'
      width={width}
      height={height}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.58 0.0137438C11.5404 0.0191678 11.4108 0.0355838 11.292 0.0501998C11.0177 0.0839438 10.5157 0.211816 10.2347 0.319552C9.17796 0.724648 8.25614 1.5004 7.69157 2.45968C7.28006 3.1589 7.00992 4.0773 7.00843 4.78202L7.008 4.99202H3.504H0V6.00002V7.00802H0.996H1.992V15.504V24H12H22.008V15.5043V7.00854L23.01 7.00228L24.012 6.99602L24.0183 5.98802L24.0245 4.98002L20.5083 4.98618L16.992 4.99233V4.78526C16.992 4.3821 16.8783 3.7954 16.7087 3.32402C16.4447 2.58995 16.079 2.01381 15.5283 1.46402C14.7786 0.715648 13.8415 0.234592 12.792 0.0592958C12.576 0.0231998 11.7399 -0.00821616 11.58 0.0137438ZM11.76 2.01945C10.5016 2.10515 9.41563 3.01974 9.0989 4.26059C9.05424 4.43558 9.0007 4.80309 9.00019 4.93802L9 4.99202H12C14.6848 4.99202 15 4.98813 15 4.95508C15 4.83066 14.9416 4.42281 14.9004 4.26002C14.6423 3.2381 13.8525 2.42118 12.8395 2.12812C12.4842 2.02533 12.1571 1.9924 11.76 2.01945ZM0.010992 6.00002C0.010992 6.56102 0.014136 6.79053 0.017976 6.51002C0.021816 6.22953 0.021816 5.77053 0.017976 5.49002C0.014136 5.20953 0.010992 5.43902 0.010992 6.00002ZM4.008 14.508V22.008H12H19.992V14.508V7.00802H12H4.008V14.508ZM7.992 14.496V18H9H10.008V14.496V10.992H9H7.992V14.496ZM13.992 14.496V18H15H16.008V14.496V10.992H15H13.992V14.496Z'
        fill={fill}
      />
    </svg>
  )
}

export default Delete
